import { Me, TeamRow } from './api';

/** 신청 화면: 이미 소속이거나 대기 중인 team 은 제출할 수 없다 */
export const canRequest = (row: TeamRow) => !row.member && !row.pending;

export const teamLabel = (row: TeamRow) => {
  if (row.member) return '소속';
  if (row.pending) return '대기 중';
  return row.protected ? 'portal-admin 승인' : '';
};

const approveTeams = (permissions: string[]) => permissions.filter(p => p.startsWith('access.approve:')).map(p => p.slice('access.approve:'.length));

/** 승인 화면·사이드바 노출: 어떤 team 이든 승인권이 있거나 portal.admin */
export const isApprover = (me?: Pick<Me, 'permissions'>) => !!me && (me.permissions.includes('portal.admin') || approveTeams(me.permissions).length > 0);
export const isPortalAdmin = (me?: Pick<Me, 'permissions'>) => !!me?.permissions.includes('portal.admin');
/** 내가 승인·회수할 수 있는 team (portal.admin 은 전부 — 서버가 15개를 모두 돌려준다) */
export const manageableTeams = (me?: Pick<Me, 'permissions'>) => (me ? approveTeams(me.permissions) : []);

export type ApprovalTab = 'pending' | 'history' | 'members' | 'approvers' | 'mapping';
/** 탭 ④ 승인자 지정·⑤ mapping 은 portal.admin 만 */
export const visibleTabs = (me?: Pick<Me, 'permissions'>): ApprovalTab[] => {
  if (!isApprover(me)) return [];
  const base: ApprovalTab[] = ['pending', 'history', 'members'];
  return isPortalAdmin(me) ? [...base, 'approvers', 'mapping'] : base;
};
